<template>
  <div class="sidebar-pinned">
    <Navbar />
    <main class="admin-main">

      <!-- ── Page Header ── -->
      <div class="page-header">
        <div class="container">
          <div class="d-flex align-items-center justify-content-between text-white" style="padding: 32px 0;">
            <div class="d-flex align-items-center">
              <div class="header-icon-wrap mr-3">
                <i class="fe fe-grid" style="font-size: 22px;"></i>
              </div>
              <div>
                <h4 class="mb-0 font-weight-bold">Welcome, {{ user.firstname }}</h4>
                <small style="opacity: 0.8;">{{ agency.agency_name }}</small>
              </div>
            </div>
            <div class="d-flex align-items-center" style="gap: 14px;">
              <small style="opacity: 0.65; font-size: 0.78rem;">
                <i class="fe fe-calendar mr-1"></i> {{ today }}
              </small>
              <TodayTasks />
            </div>
          </div>
        </div>
      </div>

      <section class="admin-content" style="margin-top: -20px;">
        <div class="container pb-5">

          <!-- ── Stat Cards ── -->
          <div class="row mb-4">
            <div class="col-lg-6 col-md-6">
              <div class="stat-card">
                <div class="stat-icon-wrap" style="background: #e8f4ff;">
                  <i class="fe fe-home" style="color: #2563eb; font-size: 1.3rem;"></i>
                </div>
                <div>
                  <p class="stat-label">Health Facilities</p>
                  <h3 class="stat-value">{{ providers.length || 0 }}</h3>
                </div>
                <router-link to="/providers" class="stat-link">
                  <i class="fe fe-arrow-right"></i>
                </router-link>
              </div>
            </div>

            <div class="col-lg-6 col-md-6">
              <div class="stat-card">
                <div class="stat-icon-wrap" style="background: #f0fdf4;">
                  <i class="fe fe-users" style="color: #059669; font-size: 1.3rem;"></i>
                </div>
                <div>
                  <p class="stat-label">Enrollees</p>
                  <h3 class="stat-value">
                    <router-link to="/view-clients-agency" class="text-dark"
                      style="text-decoration: none;">View</router-link>
                  </h3>
                </div>
                <router-link to="/manage-clients" class="stat-link">
                  <i class="fe fe-arrow-right"></i>
                </router-link>
              </div>
            </div>
          </div>

          <!-- ── LGA Data ── -->
          <div class="card shadow-sm table-card">
            <div class="form-card-header">
              <div class="section-number">
                <i class="fe fe-map-pin" style="font-size: 12px;"></i>
              </div>
              <h6 class="mb-0 font-weight-bold text-white">LGA Overview</h6>
            </div>
            <div class="card-body p-0">
              <lgadata />
            </div>
          </div>

        </div>
        <Footer />
      </section>
    </main>
  </div>
</template>

<script>
  import Navbar from "@/views/Navbar.vue";
  import TodayTasks from "@/components/TodayTasks.vue";
  import Footer from "@/views/Footer.vue";
  import lgadata from "@/views/shis/components/lgadata.vue";
  import moment from "moment";
  let agency = JSON.parse(localStorage.getItem("agency"));

  export default {
    components: { Navbar, lgadata, Footer, TodayTasks },
    data() {
      return {
        agency,
        auth_user: "",
        clients: { data: [] },
        providers: "",
        user: null,
        today: moment().format("dddd, MMMM Do YYYY"),
      };
    },
    beforeMount() {
      this.user = JSON.parse(localStorage.getItem("user"));
    },
    methods: {
      getClients() {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.axios
          .get(`/api/v1/auth/getUsersfilterparams`, {
            params: { page: 1, agency_id: agency.id },
          })
          .then((response) => { this.clients = response.data; })
          .catch((error) => { console.error(error); });
      },
      getProviders() {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.axios
          .get(`/api/v1/auth/providerAgency/${this.user.institutional_id}`)
          .then((response) => { this.providers = response.data.data; })
          .catch((error) => { console.error(error); });
      },
    },
    created() {
      // this.getClients();
      // this.getProviders();
    },
  };
</script>

<style scoped>
  .page-header {
    background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
    padding-bottom: 40px;
  }

  .header-icon-wrap {
    width: 48px;
    height: 48px;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .stat-card {
    display: flex;
    align-items: center;
    gap: 16px;
    background: #fff;
    border: 1px solid #e9ecef;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
    margin-bottom: 16px;
    transition: box-shadow 0.15s;
  }

  .stat-card:hover {
    box-shadow: 0 4px 16px rgba(37, 99, 235, 0.1);
  }

  .stat-icon-wrap {
    width: 52px;
    height: 52px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .stat-label {
    font-size: 0.72rem;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: #94a3b8;
    margin-bottom: 2px;
    font-weight: 600;
  }

  .stat-value {
    font-size: 1.6rem;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 0;
    line-height: 1.2;
  }

  .stat-link {
    margin-left: auto;
    width: 32px;
    height: 32px;
    background: #f1f5f9;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #64748b;
    text-decoration: none;
    flex-shrink: 0;
    transition: background 0.15s, color 0.15s;
  }

  .stat-link:hover {
    background: #2563eb;
    color: #fff;
    text-decoration: none;
  }

  .table-card {
    border-radius: 12px;
    border: 1px solid #e9ecef;
    overflow: hidden;
  }

  .form-card-header {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px 20px;
    background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
  }

  .section-number {
    width: 28px;
    height: 28px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    flex-shrink: 0;
  }
</style>